<template>
  <div id="footer" style="min-width: 1200px">

    <div class="content01" style="height: 300px;background-color: #dadee1;">
      <div class="center" style="text-align: center;">
        <div style="margin-top: 30px;">
          <img src="/static/img/header/logo_top.png" style="margin: 0 auto;height: 80px;" alt="常熟金标气门咀"/>
        </div>
        <div style="margin-top: 20px;">
          <a href="/" style="font-size: 20px;color: #747577;" @click="jumpPage('/')">官网首页</a>
          <a href="#" style="font-size: 20px;padding-left: 70px;color: #747577;" @click="jumpPage('CompanyIntroduction')">公司简介</a>
          <a href="#" style="font-size: 20px;padding-left: 70px;color: #747577;" @click="jumpPage('ProductCenter')">产品中心</a>
         <!-- <a href="#" style="font-size: 20px;padding-left: 70px;color: #747577;" @click="jumpPage('NewsInformation')">新闻资讯</a>-->
          <a href="#" style="font-size: 20px;padding-left: 70px;color: #747577;" @click="jumpPage('ContactUs')">联系我们</a>
        </div>

        <br/>
        <br/>
        <p style="font-size: 18px;color: #666666;">
          地  址: 江苏省苏州市常熟市尚湖镇查林路15号
        </p>
        <br/>
        <p style="font-size: 18px;color: #666666;">
          电  话: 15851531939 15895451354
        </p>
      </div>
      <div class="" style="background-color: #dadee1;height: 38px;text-align: center;">
        <p style="font-size: 18px;color: rgb(102,102,102);margin-top: 10px">COPYRIGHT © 2010-2022 常熟市金标气门咀有限公司 版权所有
          网站备案号: <a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2022004945号</a></p>
      </div>
    </div>

    <!--<div class="footer02" style="height: 10px;">

    </div>-->


  </div>
</template>
<script>
  import  '@/assets/css/cpjfw.css';
  import  '@/assets/css/shouye.css';
export default {
  name: "Footer",
  data() {

    return {
      contract:{
        name:'',
        content:'',
        telephoneNum:'',
        email:'',
        address:''
      },
    };
  },
  created(){
    //this.getContract()
  },
  methods: {
      jumpPage(url) {
          this.$router.push({
              path: '/' + url,
              name: url,
              component: resolve => require(['@/view/' + url], resolve),
          });
      },

    getContract(){
      this.$http({
        method:'post',
        url:'/getContract',
        params:{},
      })
        .then((data) => {
          this.contract.name = data.data.ci.name
          this.contract.content = data.data.ci.content
          this.contract.telephoneNum = data.data.ci.telephoneNum
          this.contract.email = data.data.ci.email
          this.contract.address = data.data.ci.address
        })
    }
  }
};
</script>
<style scoped>
#footer {
/*  width: 100%;
  height: 100%;
  color: #fff;
  background: rgb(218,222,225);
  overflow: hidden;
  text-align: center;*/
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: rgb(25,25,25);
  font-size: 14px;
  margin: 5px 0;
}
.email_wx {
  color: rgb(25,25,25);
  font-size: 14px;
}
.copy {
  color: rgb(25,25,25);
  font-size: 14px;
  margin: 15px 0 10px;
}
.footer02{
  margin: 1px auto;
}


</style>



// WEBPACK FOOTER //
// src/components/Footer.vue